// extracted by mini-css-extract-plugin
module.exports = {"container":"HeadingSection_container__G7bzQ","title":"HeadingSection_title__2XpmJ"};